// Observable for whether this origin's storage is persistent (exempt from
// browser eviction). Fed by the boot-time requestPersistentStorage() call in
// main.tsx; consumed by DurabilityBanner, which warns when storage is
// best-effort — the enabling condition of the "knitted for hours, nothing
// saved" class of loss on iOS. Mirrors the saveStatus.ts observable shape.
import { requestPersistentStorage, type PersistResult } from './persistentStorage';

export type DurabilityStatus = 'unknown' | PersistResult;

let status: DurabilityStatus = 'unknown';

type Callback = () => void;
const callbacks: Callback[] = [];

function emit(): void {
  callbacks.forEach((cb) => cb());
}

export function getDurabilityStatus(): DurabilityStatus {
  return status;
}

export function subscribeDurability(cb: Callback): () => void {
  callbacks.push(cb);
  return () => {
    const idx = callbacks.indexOf(cb);
    if (idx >= 0) callbacks.splice(idx, 1);
  };
}

export function setDurabilityStatus(result: PersistResult): void {
  if (status === result) return;
  status = result;
  emit();
}

/**
 * Retry the persist request. Grants correlate with user engagement, so this
 * is called on a user gesture after an initial denial.
 */
export async function reRequestPersistentStorage(): Promise<void> {
  setDurabilityStatus(await requestPersistentStorage());
}

// Test-only: reset module state between tests.
export function __resetDurabilityForTest(): void {
  status = 'unknown';
  callbacks.length = 0;
}
